"use client";
import { useState, useEffect } from "react";
import Link from "next/link";

interface CategoriesComponentProps {
  data: any[];
  selectedCategory: any;
}

export default function CategoriesComponent({ data, selectedCategory }: CategoriesComponentProps) {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [filteredCalculators, setFilteredCalculators] = useState<any[]>([]);

  useEffect(() => {
    if (data) {
      if (selectedCategory) {
        setSelectedCategories([selectedCategory?.category_name]);
      } else {
        setSelectedCategories(data.map((category) => category.category_name));
      }
    }
  }, [data])

  useEffect(() => {
    filterCalculators();
  }, [searchTerm, selectedCategories]);

  const filterCalculators = () => {
    let calculators: any[] = [];

    data.forEach((category) => {
      if (selectedCategories.includes(category.category_name)) {
        const filtered = category.calculators.filter((calculator: any) =>
          calculator.calculator_name.toLowerCase().includes(searchTerm.toLowerCase())
        );
        calculators = calculators.concat(filtered);
      }
    });

    setFilteredCalculators(calculators);
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const handleCategoryChange = (categoryName: string) => {
    setSelectedCategories((prevSelectedCategories) =>
      prevSelectedCategories.includes(categoryName)
        ? prevSelectedCategories.filter((name) => name !== categoryName)
        : [...prevSelectedCategories, categoryName]
    );
  };

  const handleSelectAll = () => {
    if (selectedCategories.length === data.length) {
      setSelectedCategories([]);
    } else {
      setSelectedCategories(data.map((category) => category.category_name));
    }
  };

  return (
    <div className="container mx-auto p-4">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Sidebar */}
        <div className="lg:col-span-1">
          <div className="bg-white p-4 shadow rounded">
            <h2 className="text-xl font-semibold mb-4">Advanced Filter</h2>
            <div className="mb-4">
              <label className="block text-gray-700">Search</label>
              <input
                type="text"
                placeholder="Search"
                value={searchTerm}
                onChange={handleSearchChange}
                className="w-full p-2 border border-gray-300 rounded"
              />
            </div>
            <div className="mb-6 p-4 bg-white shadow-lg rounded-lg">
              <label className="block text-lg font-semibold text-gray-800 mb-3">Categories</label>
              <div className="flex flex-col space-y-2 max-h-64 overflow-y-auto">
                <label className="inline-flex items-center cursor-pointer hover:bg-gray-100 p-2 rounded-lg transition-all duration-150">
                  <input
                    type="checkbox"
                    className="form-checkbox h-5 w-5 text-blue-600 rounded focus:ring-blue-500 focus:ring-opacity-50"
                    checked={selectedCategories.length === data.length}
                    onChange={handleSelectAll}
                  />
                  <span className="ml-3 text-gray-700 text-sm">All</span>
                </label>
                {data.map((item) => (
                  <label key={item.category_name} className="inline-flex items-center cursor-pointer hover:bg-gray-100 p-2 rounded-lg transition-all duration-150">
                    <input
                      type="checkbox"
                      className="form-checkbox h-5 w-5 text-blue-600 rounded focus:ring-blue-500 focus:ring-opacity-50"
                      checked={selectedCategories.includes(item.category_name)}
                      onChange={() => handleCategoryChange(item.category_name)}
                    />
                    <span className="ml-3 text-gray-700 text-sm">{item.category_name}</span>
                  </label>
                ))}
              </div>
            </div>

          </div>
        </div>

        {/* Listings */}
        <div className="lg:col-span-2">
          <h2 className="text-xl font-semibold mb-4">
            {filteredCalculators.length} tools are available
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {filteredCalculators.map((calculator, index) => (
              <Link
                href={`/${calculator.calculator_slug}`}
                key={index}
                className="card bg-white p-6 cursor-pointer rounded-lg shadow-md text-center border border-black flex justify-center items-center transition-transform transform hover:scale-105"
              >
                <p className="text-lg font-semibold text-black">
                  {calculator.calculator_name}
                </p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
